import { render } from "./editApply.vue?vue&type=template&id=5d53a55c&scoped=true"
import script from "./editApply.vue?vue&type=script&lang=js"
export * from "./editApply.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d53a55c"]])

export default __exports__